import { useState, useEffect } from 'react';

export default function ImageSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      url: 'https://static.readdy.ai/image/18ddd3c5386ce7455627992c42f8b0cb/9be1daf22c4885cdae61f9bd0d4e990c.jpeg',
      alt: 'プロの技術による丁寧な施工'
    },
    {
      url: 'https://static.readdy.ai/image/18ddd3c5386ce7455627992c42f8b0cb/0322e582eef50c49fae7e33b3a29bc61.jpeg',
      alt: 'ガレージでの施工風景'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-screen overflow-hidden">
      {/* 画像スライド */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.url}
            alt={slide.alt}
            className="w-full h-full object-cover object-center"
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        </div>
      ))}

      {/* オーバーレイ - クリックで予約ページへ */}
      <div 
        onClick={() => window.REACT_APP_NAVIGATE('/service-select')}
        className="absolute inset-0 bg-black/30 cursor-pointer"
      ></div>

      {/* スライドインジケーター */}
      <div className="absolute bottom-[25%] left-1/2 transform -translate-x-1/2 z-10 flex gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              setCurrentSlide(index);
            }}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide 
                ? 'bg-white w-8' 
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`スライド${index + 1}へ移動`}
          />
        ))}
      </div>

      {/* 料金シミュレーターボタン - 下寄り中央 */}
      <div className="absolute inset-x-0 bottom-[15%] z-10 flex items-center justify-center pointer-events-none">
        <div className="w-full px-6 md:px-12 lg:px-20 max-w-7xl mx-auto pointer-events-none flex justify-center">
          <button 
            onClick={(e) => {
              e.stopPropagation();
              window.REACT_APP_NAVIGATE('/service-select');
            }}
            className="w-full md:w-auto bg-gradient-to-r from-blue-600 to-blue-700 text-white px-12 py-5 rounded-2xl text-xl md:text-2xl font-bold hover:from-blue-700 hover:to-blue-800 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-2xl pointer-events-auto transform hover:scale-105"
          >
            <i className="ri-calculator-line mr-3"></i>
            料金シミュレーターを見る
          </button>
        </div>
      </div>

      {/* ロゴとCTAボタン */}
      <div className="absolute top-8 left-0 right-0 z-20 px-6">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          {/* ロゴ */}
          <div className="text-white">
            <h1 className="text-3xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
              logo
            </h1>
          </div>

          {/* CTAボタン */}
          <button 
            onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-calendar-line mr-2"></i>
            今すぐ予約
          </button>
        </div>
      </div>
    </section>
  );
}
